import styled, { css } from 'styled-components';

interface IButton {
  active: boolean;
}

interface ISelector {
  advanced: boolean;
}

export const Selector = styled.div<ISelector>`
  ${({ advanced }) => css `
    padding-bottom: 10px;
    width: ${ advanced? '680px' : '480px' };
  `}
`

export const Wrapper = styled.div<{ zIndex: number }>`
  ${({ theme, zIndex }) => css`
    position: fixed;
    bottom: 25%;
    z-index: ${zIndex};
    display: flex;
    right: calc(50% - 275px);

    p {
      font-family: ${theme.font.family.default};
    }

    @media (max-width: 1680px) {
      right: calc(50% - 300px);
    }

    @media (max-width: 1440px) {
      right: calc(50% - 325px);
    }

    @media (max-width: 1280px) {
      right: calc(50% - 405px);
    }
  `}
`;

export const Modal = styled.div`
  ${({ }) => css`
    display: inline-block;
  `}
`;

export const Header = styled.div`
  ${({ }) => css`
    display: flex;
  `}
`;

export const Tab = styled.button<IButton>`
  ${({ theme, active }) => css`
    display: flex;
    gap: 10px;
    border: 1px solid black;
    border-bottom: 0;
    padding: 5px 10px 5px 10px;

    font-size: ${theme.font.sizes.sm};
    font-weight: ${theme.font.weights.bold};

    background-color: ${active? theme.colors.blueGray700 : theme.colors.white};
    color: ${active? theme.colors.white: theme.colors.black};
  `}
`;

export const Features = styled.div`
  ${({ theme }) => css`
    display: contents;

    p {
      font-family: ${theme.font.family.default};
    }
  `}
`;

export const SimpleLayers = styled.div`
  ${({ }) => css`
    display: flex;
    flex-direction: column;
    gap: 16px;
    max-height: 520px;
    overflow: auto;
    padding: 6px 4px;
  `}
`;

export const SimpleLayer = styled.div`
  ${({ theme }) => css`
    border: 1px solid ${theme.colors.black};
    padding: 10px;
    background: ${theme.colors.white};
  `}
`;

export const SimpleLayerTitle = styled.h4`
  ${({ theme }) => css`
    margin: 0 0 10px;
    font-size: ${theme.font.sizes.md};
    font-weight: ${theme.font.weights.bold};
  `}
`;

export const SimpleLayerError = styled.div`
  ${({ theme }) => css`
    font-size: ${theme.font.sizes.lg};
    font-weight: ${theme.font.weights.bold};

    display: flex;
    position: relative;
    justify-content: center;
    align-items: center;

    padding: 10px;
    width: 100%;
    min-height: 160px;
    border: 1px solid ${theme.colors.black};

    .watermark {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 160px;
      opacity: 0.08;
      pointer-events: none;
    }
  `}
`;
